export const state = () => ({
  current: '',
});

export const actions = {
};

export const mutations = {
  set(state, value) {
    state.current = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
